import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import injectStyles from 'react-jss';

import { tagStyles } from './css/new-styles';

function useWindowWidth() {
  const [width, setWidth] = useState(0);
  useLayoutEffect(() => {
    function updateWidth() {
      setWidth(window.innerWidth);
    }
    window.addEventListener('resize', updateWidth);
    updateWidth();
    return () => window.removeEventListener('resize', updateWidth);
  }, []);
  return width;
}

export const CouponTagNew = injectStyles(tagStyles)(({
  classes,
  coupon,
  i18n,
  clearFloats,
}) => {
  const windowWidth = useWindowWidth();
  const tagRef = useRef(null);
  const currentTagRef = tagRef.current;
  const middleOfCurrentTag = currentTagRef &&
    (currentTagRef.getBoundingClientRect().x + (currentTagRef.offsetWidth / 2));
  const isFlyoutOnRight = middleOfCurrentTag
    ? middleOfCurrentTag / windowWidth < 0.5
    : false;

  return (
    <div>
      <span className={classNames('coupon-tag-with-extension', classes.tagWithExtension)} >
        <span ref={tagRef} className={classNames('coupon-tag', classes.tag)} >
          <span className={classes.mainTriangle} />
          <span className={classNames('coupon-tag-message', classes.mainContainer)} >
            {i18n.getString('Coupon_TagMessageNew', coupon)}
          </span>
        </span>
        <div
          className={classNames('coupon-tag-flyout', classes.flyout, isFlyoutOnRight ? 'right' : 'left')}
        >
          <div className={classNames('coupon-tag-flyout-content', classes.flyoutContent)} >
            <p className={classes.flyoutContentLine1} >
              {i18n.getString('Coupon_TagFlyoutMessage', coupon)}
            </p>
            <p className={classes.flyoutContentLine2} >
              {i18n.getString('Coupon_Lightbox_LimitedTimeOffer')}
            </p>
          </div>
        </div>
      </span>
      {clearFloats && <span className={classes.clearFloats} />}
    </div>
  );
});

CouponTagNew.propTypes = {
  coupon: PropTypes.shape({
    value: PropTypes.string.isRequired,
    expirationDate: PropTypes.string.isRequired,
    tagMessage: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  clearFloats: PropTypes.bool,
};

CouponTagNew.defaultProps = {
  clearFloats: false,
};
